export const FONT_MODE_STOTAGE_KEY = 'script-font-mode';
export const CODE_THEME_STOTAGE_KEY = 'script-code-theme';
export const SHOW_ADD_GITHUB_REPO_POPUP_KEY = 'show-add-github-repo-popup';